const environment = {
  Auth0: {
    clientId: () => {
      switch (process.env.REACT_APP_ENV) {
      case 'dev':
        return 'FK5OTurZEBcZbUwSlMpOBAAn3TM8zVLB';
      case 'uat':
        return '79IwbpoXyF0c8E1sKHRmaP1YAerp9Zpp';
      case 'staging':
        return 'RsfIXfpqPqeryOnJD8TRMyIVL9qbCyN9';
      case 'prod':
        return '2c6A4eiCkLYWiQtGjoU7FI7izvisXLdO';
      default:
        // TODO change this to properly set env variable config on start
        return 'FK5OTurZEBcZbUwSlMpOBAAn3TM8zVLB';
      }
    },
    domain: () => {
      switch (process.env.REACT_APP_ENV) {
      case 'dev':
        return 'https://oncolens-dev.us.auth0.com';
      case 'uat':
        return 'https://login.oncolens.dev';
      case 'staging':
        return 'https://login.staging.oncolens.com';
      case 'prod':
        return 'https://login.oncolens.com';
      default:
        // TODO change this to properly set env variable config on start
        return 'https://oncolens-dev.us.auth0.com';
      }
    }
  },
  Oncolens: {
    authServer: () => {
      switch (process.env.REACT_APP_ENV) {
      case 'dev':
        return 'https://localhost:5001/';
      case 'uat':
        return 'https://auth.services.oncolens.dev/';
      case 'staging':
        return 'https://auth.services.staging.oncolens.com/';
      case 'prod':
        return 'https://auth.services.oncolens.com/';
      default:
        // TODO change this to properly set env variable config on start
        return 'https://localhost:5001/';
      }
    }
  }
};

export default environment;
